import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.reduce.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  style: {
    "display": "flex",
    "flex-wrap": "wrap",
    "max-height": "500px"
  }
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  style: {
    "display": "flex",
    "flex-wrap": "wrap",
    "max-height": "500px"
  }
};
const _hoisted_4 = ["onClick"];
import { Search } from '@element-plus/icons-vue';
import elementIcons from './element-icons';
import * as Icons from '@element-plus/icons-vue';
import svgIcons from './svg-icons';

import { computed, ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'XIconSelect',
  props: {
    modelValue: {}
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const prop = __props;
    const emit = __emit;
    const selectVal = computed({
      get() {
        return prop.modelValue;
      },
      set(newVal) {
        emit('update:modelValue', newVal);
      }
    });
    const visible = ref(false);
    const activeName = ref('element');
    const icons = elementIcons.map(icon => {
      const res = icon.split('-').reduce((pre, current) => {
        pre = pre ? pre[0].toLocaleUpperCase() + pre.slice(1) : '';
        current = current ? current[0].toLocaleUpperCase() + current.slice(1) : '';
        return pre + current;
      }, '');
      return {
        icon: res,
        value: icon
      };
    });
    function open() {
      visible.value = true;
    }
    function close() {
      visible.value = false;
    }
    function select(icon) {
      emit('update:modelValue', 'el-icon-' + icon);
      close();
    }
    function selectSvg(icon) {
      emit('update:modelValue', icon);
      close();
    }
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_SvgIcon = _resolveComponent("SvgIcon");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_input, {
        modelValue: _unref(selectVal),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(selectVal) ? selectVal.value = $event : null),
        clearable: "",
        placeholder: "请选择或输入图标"
      }, {
        append: _withCtx(() => [_createVNode(_component_el_button, {
          icon: _unref(Search),
          onClick: open
        }, null, 8, ["icon"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "50%",
        title: "图标"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tabs, {
          modelValue: _unref(activeName),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(activeName) ? activeName.value = $event : null),
          class: "demo-tabs"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
            label: "Element图标",
            name: "element"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
              height: "500px"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(icons), (item, index) => {
                return _openBlock(), _createElementBlock("div", {
                  key: index,
                  style: {
                    "text-align": "center",
                    "margin": "20px 15px",
                    "width": "100px",
                    "height": "85px",
                    "cursor": "pointer"
                  },
                  onClick: $event => select(item.value)
                }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Icons[item.icon]), {
                  style: {
                    "width": "25px",
                    "height": "25px"
                  }
                })), _createElementVNode("div", null, _toDisplayString(item.icon), 1)], 8, _hoisted_2);
              }), 128))])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            label: "用户图标",
            name: "svg"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
              height: "500px"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(svgIcons), (item, index) => {
                return _openBlock(), _createElementBlock("div", {
                  key: index,
                  style: {
                    "text-align": "center",
                    "margin": "20px 15px",
                    "width": "100px",
                    "height": "85px",
                    "cursor": "pointer"
                  },
                  onClick: $event => selectSvg(item)
                }, [_createVNode(_component_SvgIcon, {
                  style: {
                    "width": "25px",
                    "height": "25px"
                  },
                  "icon-class": item
                }, null, 8, ["icon-class"]), _createElementVNode("div", null, _toDisplayString(item), 1)], 8, _hoisted_4);
              }), 128))])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});